"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountApiKeyApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var AccountApiKeyApi = /** @class */ (function (_super) {
    __extends(AccountApiKeyApi, _super);
    function AccountApiKeyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint for /endpoint/org/deleteApiKey
     */
    AccountApiKeyApi.prototype.accountApiKeyDeleteRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["guid"] == null) {
                            throw new runtime.RequiredError("guid", 'Required parameter "guid" was null or undefined when calling accountApiKeyDelete().');
                        }
                        queryParameters = {};
                        if (requestParameters["guid"] != null) {
                            queryParameters["guid"] = requestParameters["guid"];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/endpoint/org/deleteApiKey",
                                method: "DELETE",
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.AccountApiKeySuccessResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/deleteApiKey
     */
    AccountApiKeyApi.prototype.delete = function (guid, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountApiKeyDeleteRaw({ guid: guid }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/GenerateApiKey
     */
    AccountApiKeyApi.prototype.accountApiKeyGenerateRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_1, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["accountApiKeyGenerateRequest"] == null) {
                            throw new runtime.RequiredError("accountApiKeyGenerateRequest", 'Required parameter "accountApiKeyGenerateRequest" was null or undefined when calling accountApiKeyGenerate().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.accountApiKeyGenerateRequest, index_1.attributeTypeMapAccountApiKeyGenerateRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_1 = (0, index_1.AccountApiKeyGenerateRequestToJSON)(jsonData);
                            Object.keys(jsonBody_1).forEach(function (key) {
                                if (jsonBody_1[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_1[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.AccountApiKeyGenerateRequestToJSON)(requestParameters.accountApiKeyGenerateRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/endpoint/org/GenerateApiKey",
                                method: "POST",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.AccountApiKeySuccessResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/GenerateApiKey
     */
    AccountApiKeyApi.prototype.generate = function (accountApiKeyGenerateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountApiKeyGenerateRaw({ accountApiKeyGenerateRequest: accountApiKeyGenerateRequest }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/listApiKey
     */
    AccountApiKeyApi.prototype.accountApiKeyListRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/endpoint/org/listApiKey",
                                method: "GET",
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.AccountApiKeyListResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/listApiKey
     */
    AccountApiKeyApi.prototype.list = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountApiKeyListRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/markApiKeyAsPrimary
     */
    AccountApiKeyApi.prototype.accountApiKeyMarkAsPrimaryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_2, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["accountApiKeyMarkAsPrimaryRequest"] == null) {
                            throw new runtime.RequiredError("accountApiKeyMarkAsPrimaryRequest", 'Required parameter "accountApiKeyMarkAsPrimaryRequest" was null or undefined when calling accountApiKeyMarkAsPrimary().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.accountApiKeyMarkAsPrimaryRequest, index_1.attributeTypeMapAccountApiKeyMarkAsPrimaryRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_2 = (0, index_1.AccountApiKeyMarkAsPrimaryRequestToJSON)(jsonData);
                            Object.keys(jsonBody_2).forEach(function (key) {
                                if (jsonBody_2[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_2[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.AccountApiKeyMarkAsPrimaryRequestToJSON)(requestParameters.accountApiKeyMarkAsPrimaryRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/endpoint/org/markApiKeyAsPrimary",
                                method: "PUT",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.AccountApiKeySuccessResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/markApiKeyAsPrimary
     */
    AccountApiKeyApi.prototype.markAsPrimary = function (accountApiKeyMarkAsPrimaryRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountApiKeyMarkAsPrimaryRaw({ accountApiKeyMarkAsPrimaryRequest: accountApiKeyMarkAsPrimaryRequest }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/renameApiKey
     */
    AccountApiKeyApi.prototype.accountApiKeyRenameRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, result, localVarUseFormData, formData, jsonData, body, jsonBody_3, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters["accountApiKeyRenameRequest"] == null) {
                            throw new runtime.RequiredError("accountApiKeyRenameRequest", 'Required parameter "accountApiKeyRenameRequest" was null or undefined when calling accountApiKeyRename().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        result = runtime.generateFormData(requestParameters.accountApiKeyRenameRequest, index_1.attributeTypeMapAccountApiKeyRenameRequest);
                        localVarUseFormData = result.localVarUseFormData;
                        formData = result.formData;
                        jsonData = result.jsonData;
                        if (localVarUseFormData) {
                            /**
                             * IMPORTANT: WE MUST DELETE "Content-Type"!
                             * When a request is multipart/form-data we must NOT set Content-Type
                             * otherwise the browser will mess up the boundary!
                             */
                            delete headerParameters["Content-Type"];
                            jsonBody_3 = (0, index_1.AccountApiKeyRenameRequestToJSON)(jsonData);
                            Object.keys(jsonBody_3).forEach(function (key) {
                                if (jsonBody_3[key] == null) {
                                    return;
                                }
                                formData.append(key, jsonBody_3[key]);
                            });
                            body = formData;
                        }
                        else {
                            headerParameters["Content-Type"] = "application/json";
                            body = (0, index_1.AccountApiKeyRenameRequestToJSON)(requestParameters.accountApiKeyRenameRequest);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/endpoint/org/renameApiKey",
                                method: "PUT",
                                headers: headerParameters,
                                query: queryParameters,
                                body: body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return (0, index_1.AccountApiKeySuccessResponseFromJSON)(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Endpoint for /endpoint/org/renameApiKey
     */
    AccountApiKeyApi.prototype.rename = function (accountApiKeyRenameRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountApiKeyRenameRaw({ accountApiKeyRenameRequest: accountApiKeyRenameRequest }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AccountApiKeyApi;
}(runtime.BaseAPI));
exports.AccountApiKeyApi = AccountApiKeyApi;
